var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
// Internal
import SingleSelect from "../asyncDropdown/SingleSelect";
import { useAccountSearchQuery } from "./accountsGQL";
import useSelectSearch from "../asyncDropdown/useSelectSearch";
var useStyles = makeStyles(function (_a) {
    var _b;
    var breakpoints = _a.breakpoints, spacing = _a.spacing;
    return ({
        accountChild: {
            paddingRight: spacing(1),
        },
        accountInfo: (_b = {
                display: "flex",
                flex: "1 1 0%",
                justifyContent: "flex-end"
            },
            _b[breakpoints.up("md")] = {
                display: "inline-block",
                minWidth: spacing(28),
                paddingRight: spacing(2),
                verticalAlign: "middle",
            },
            _b),
    });
});
var extractData = function (data) {
    return data && data.accounts ? data.accounts : [];
};
export default (function (props) {
    var _a = useSelectSearch(), searchString = _a.searchString, onInputChange = _a.onInputChange;
    var _b = useAccountSearchQuery({
        variables: { search: "".concat(searchString, "%") },
    }), data = _b.data, loading = _b.loading;
    var breakpoints = useTheme().breakpoints;
    var isUpMd = useMediaQuery(breakpoints.up("md"));
    var options = extractData(data);
    var classes = useStyles();
    return (React.createElement(React.Fragment, null,
        isUpMd && (React.createElement("div", { className: classes.accountChild },
            React.createElement(Typography, { variant: "h4" }, "Account:"))),
        React.createElement("div", { className: classes.accountInfo },
            React.createElement(SingleSelect, __assign({ placeholder: "Select an Account", whiteTheme: true, options: options, loading: loading, onInputChange: onInputChange }, props)))));
});
//# sourceMappingURL=AccountSelect.js.map